/* house of zelena — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE DRAWER ── */
  const menuBtn    = document.getElementById('menuBtn');
  const drawer     = document.getElementById('drawer');
  const drawerBg   = document.getElementById('drawerBg');
  const drawerClose = document.getElementById('drawerClose');

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuBtn)     menuBtn.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerBg)    drawerBg.addEventListener('click', closeDrawer);

  // Close drawer on stage links (they scroll to anchor)
  document.querySelectorAll('.drawer-stage-row').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // ESC key closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) {
      closeDrawer();
    }
  });


  /* ── SLIDESHOW ── */
  const slideshow  = document.getElementById('slideshow');
  const track      = document.getElementById('slidesTrack');
  const dotsWrap   = document.getElementById('slideControls');
  const prevBtn    = document.getElementById('slidePrev');
  const nextBtn    = document.getElementById('slideNext');

  if (!track) return; // No slideshow on this page

  const slides     = track.querySelectorAll('.slide');
  const totalSlides = slides.length;
  let current      = 0;
  let autoTimer    = null;

  // Read autoplay speed from data attribute (set via Liquid)
  const INTERVAL = (parseInt(slideshow.dataset.speed) || 5) * 1000;

  // Build dot indicators
  slides.forEach(function (_, i) {
    const dot = document.createElement('button');
    dot.className = 'slide-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.addEventListener('click', function () { goTo(i, true); });
    dotsWrap.appendChild(dot);
  });

  function updateDots() {
    dotsWrap.querySelectorAll('.slide-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === current);
    });
  }

  function goTo(n, resetTimer) {
    current = ((n % totalSlides) + totalSlides) % totalSlides;
    track.style.transform = 'translateX(-' + current * 100 + '%)';
    updateDots();
    if (resetTimer) {
      clearInterval(autoTimer);
      startAuto();
    }
  }

  function startAuto() {
    autoTimer = setInterval(function () { goTo(current + 1, false); }, INTERVAL);
  }

  startAuto();

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1, true); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1, true); });

  // Pause on hover (desktop)
  slideshow.addEventListener('mouseenter', function () { clearInterval(autoTimer); });
  slideshow.addEventListener('mouseleave', startAuto);

  // Touch / swipe support (mobile)
  let touchStartX = null;
  slideshow.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  slideshow.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) goTo(current + (dx < 0 ? 1 : -1), true);
    touchStartX = null;
  }, { passive: true });


  /* ── MEGA MENU ACCESSIBILITY ── */
  document.querySelectorAll('.nav-item').forEach(function (item) {
    const btn  = item.querySelector('button.nav-link');
    const mega = item.querySelector('.mega');
    if (!btn || !mega) return;

    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });

    // Close mega when focus leaves
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });


  /* ── SMOOTH SCROLL for #stage-section links ── */
  document.querySelectorAll('a[href="#stage-section"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const target = document.getElementById('stage-section');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
